import React from "react";
import Colors from "../config/Colors";
import { useNavigate } from "react-router-dom";
import Strings from "../config/Strings";

function Footer({ isMobile }) {
  const navigate = useNavigate();

  const styles = {
    footer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-evenly",
      alignItems: "center",
      padding: "1rem 2rem",
      fontSize: "14px",
      gap: "10px",
      width: "100%",
      backgroundColor: "#b8143d",
    },
    leftRightGroup: {
      display: "flex",
      gap: "1rem",
      flexWrap: "wrap",
    },
    button: {
      background: "none",
      border: "none",
      color: Colors.white,
      cursor: "pointer",
      paddingRight: 10,
      fontSize: "14px",
      textDecoration: "underline",
    },
    container: (isMobile) => ({
      ...styles.footer,
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    }),
    copyright: {
      marginTop: "0.5rem",
    },
  };

  return (
    <footer style={styles.container(isMobile)}>
      <div style={styles.leftRightGroup}>
        <button
          onClick={() => {
            navigate(Strings.homeDir + "/terms", { state: { refer: true } });
          }}
          style={styles.button}
        >
          Invite-Terms{" "}
        </button>
        <button
          onClick={() => {
            navigate(Strings.homeDir + "/contact");
          }}
          style={styles.button}
        >
          Contact{" "}
        </button>
      </div>
      <div
        style={{
          ...styles.leftRightGroup,
          ...(isMobile ? styles.copyright : {}),
        }}
      >
        © {new Date().getFullYear()} Second Innings - Bloopzy. All rights
        reserved.
      </div>
    </footer>
  );
}

export default Footer;
